import { render } from "./FeaturesUpdate.vue?vue&type=template&id=c8ea1c38"
import script from "./FeaturesUpdate.vue?vue&type=script&lang=js"
export * from "./FeaturesUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__